import { render } from "./CreativeDocumentType.vue?vue&type=template&id=3f4c0f89&scoped=true"
import script from "./CreativeDocumentType.vue?vue&type=script&lang=js"
export * from "./CreativeDocumentType.vue?vue&type=script&lang=js"

import "./CreativeDocumentType.vue?vue&type=style&index=0&id=3f4c0f89&scoped=true&lang=css"

import exportComponent from "/var/www/html/clientwebview/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f4c0f89"]])

export default __exports__